import React, {Component} from 'react';
import { config } from '../../constants/domainConfig';
import { FormattedMessage } from 'react-intl';
import { checkAccess } from '../../actions/WelcomeActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class Footer extends Component {

    render() {
		let isAdmin = this.props.isAdmin;
        return (
			<footer className={config.subDomain === 'no' || config.subDomain === 'ee' || config.subDomain === 'lt' || config.subDomain === 'lv' ? 'app-footer no_app-footer' : 'app-footer'}>
				{config.subDomain == 'it' &&
					<ul className="list-unstyled footer-list">
					<li className="footer-list__item"><a className="footer-list__link" href={`http://n.mobiotv.com/it/tnc-mobiotv?offer=1&brand_name=mobiotv&_next=index.html&_extracted=fbdd153ce2d7463d8244bfee2acf150e&token=${this.props.access.uid}`} target="_blank">Termini e Condizioni</a></li>
					<li className="footer-list__item"><a className="footer-list__link" href={`http://n.mobiotv.com/it/tnc-mobiotv?offer=1&brand_name=mobiotv&_next=privacy_policy.html&_extracted=3b38e1628b10445596b79fbec1bbb3f7&token=${this.props.access.uid}`} target="_blank">Info Privacy</a></li>
					<li className="footer-list__item"><a className="footer-list__link" href={`http://n.mobiotv.com/it/tnc-mobiotv?offer=1&brand_name=mobiotv&_next=privacy_policy.html&_extracted=3b38e1628b10445596b79fbec1bbb3f7&_next=compatibility.html&_extracted=3b38e1628b10445596b79fbec1bbb3f7&token=${this.props.access.uid}`} target="_blank">Terminali Compatibili</a></li>
						<li className="footer-list__item"><a className="footer-list__link" href={`http://n.mobiotv.com/it/tnc-mobiotv?offer=1&brand_name=mobiotv&_next=compatibility.html&_extracted=3b38e1628b10445596b79fbec1bbb3f7&_next=cancellation.html&_extracted=3b38e1628b10445596b79fbec1bbb3f7&token=${this.props.access.uid}`} target="_blank">Contattaci</a></li>
						<li className="footer-list__item"><a className="footer-list__link" href={`http://n.mobiotv.com/it/tnc-mobiotv?offer=1&brand_name=mobiotv&_next=compatibility.html&_extracted=3b38e1628b10445596b79fbec1bbb3f7&_next=cancellation.html&_extracted=3b38e1628b10445596b79fbec1bbb3f7&token=${this.props.access.uid}`} target="_blank">Gestione servizio</a></li>
					</ul>
				}
					{config.subDomain == 'ee' ? 
					<ul className="list-unstyled ee-footer-list">
					<li className="ee-footer-list-items">
						<a className="ee-footer-list__link" href="http://n.mobiotv.com/ee/tnc-mobiotv?offer=1&device=pc&brand_name=mobiotv&_next=general_conditions.html" target="_blank">
							Kasutustingimused
						</a>
						<a className="ee-footer-list__link" href={`http://n.mobiotv.com/unsubscribe/ee/?country=ee&domain=ee.mobiotv.com&token=${this.props.access.uid}`} target="_blank">
							Tühistamine
						</a>
					</li>
					</ul>
					:
                    (config.subDomain == 'lv') ? 
					<ul className="list-unstyled ee-footer-list">
					<li className="ee-footer-list-items">
						<a className="ee-footer-list__link" href=" http://n.mobiotv.com/lv/tnc-mobiotv?offer=1" target="_blank">
                            NOTEIKUMI
						</a>
						{this.props.access.uid && <a className="ee-footer-list__link" href={`http://n.mobiotv.com/unsubscribe/lv/?country=lv&domain=lv.mobiotv.com&token=${this.props.access.uid}`} target="_blank">
                            ANULĒT ABONEMENTU
						</a>}
					</li>
					</ul>
                    :(config.subDomain == 'lt') ? 
					<ul className="list-unstyled ee-footer-list">
					<li className="ee-footer-list-items">
						<a className="ee-footer-list__link" href=" http://n.mobiotv.com/lt/tnc-mobiotv?offer=1" target="_blank">
                            TERMINAI IR SĄLYGOS
						</a>
						<a className="ee-footer-list__link" href={`http://n.mobiotv.com/unsubscribe/lt/?country=lt&domain=lt.mobiotv.com&token=${this.props.access.uid}`} target="_blank">
                            NUTRAUKTI PRENUMERATĄ
						</a>
					</li>
					</ul>
                    :
					(!isAdmin) ?
					<div>
						<div className="copyright">
                            {config.title == 'bidiotv' && config.mainDomain != 'mobiotv' ?
                                <p className="copyright__text">2019 &copy; BidioTV. 
								<FormattedMessage id="rights"
										defaultMessage="All Rights Reserved."
								/>
								</p>
								:
								(config.newDomain === 'fitness-bay')
								?
								<p className="copyright__text">2022 &copy; Fitness Bay. 
								{" "}<FormattedMessage id="rights"
										defaultMessage="All Rights Reserved."
								/>
								</p>
								: 
								config.newDomain === 'mobiofitplus'
								?
								<p className="copyright__text">2021 &copy; Mobiofitplus. 
								{" "}<FormattedMessage id="rights"
										defaultMessage="All Rights Reserved."
								/>
								</p>
								:
								(config.subDomain.includes('mobiofit'))
								?
								<p className="copyright__text">2020 &copy; Mobiofit. 
								{" "}<FormattedMessage id="rights"
										defaultMessage="All Rights Reserved."
								/>
								</p>
								: 
								config.newDomain === 'telemovil'
								?
								<p className="copyright__text">2020 &copy; Tele Movil. 
								{" "}<FormattedMessage id="rights"
										defaultMessage="All Rights Reserved."
								/>
								</p>
								:
								config.newDomain === 'trendme'
								?
								<p className="copyright__text">2021 &copy; Trendme. 
								{" "}<FormattedMessage id="rights"
										defaultMessage="All Rights Reserved."
								/>
								</p>
								:
								config.newDomain === 'fun-box'
								?
								<p className="copyright__text">2024 &copy; Fun Box. 
								{" "}<FormattedMessage id="rights"
										defaultMessage="All Rights Reserved."
								/>
								</p>
								:
								config.newDomain === 'vidflixz'
								?
								<p className="copyright__text">2021 &copy; Vidflixz. 
								{" "}<FormattedMessage id="rights"
										defaultMessage="All Rights Reserved."
								/>
								</p>
								:
								config.newDomain === 'flamilingo'
								?
								<p className="copyright__text">2021 &copy; Flamilingo. 
								{" "}<FormattedMessage id="rights"
										defaultMessage="All Rights Reserved."
								/>
								</p>
								:
								<div>
									{config.subDomain === 'no' ? <p className="copyright__text" style={{cursor: 'pointer'}} onClick={e => (window.location = "mailto:no@content-clubs.com")}> Kontakt: no@content-clubs.com</p> : null}
									<p className="copyright__text">2019 &copy; MobioTV.&nbsp;
								<FormattedMessage id="rights"
										defaultMessage="All Rights Reserved."
									/>
								</p>
								</div>
                            }
						</div>
					</div>
					: <div>
						2019 &copy; MobioTV. <FormattedMessage id="rights" defaultMessage="All Rights Reserved." />
					</div>
				}
			</footer>
        )
    }
}

const mapStateToProps = (state) => {
	return {
		access: state.WelcomeReducer
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		checkAccess,
		
	}, dispatch);
};


export default connect(mapStateToProps, mapDispatchToProps)(Footer);


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js